import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootElement = document.getElementById("root");
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If pre-rendered content exists (from react-snap), hydrate to attach React
// Otherwise, do a fresh render (dev mode)
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
  // react-helmet-async duplicates title/meta during hydration.
  // Use MutationObserver to catch and remove duplicates the instant they appear.
  const observer = new MutationObserver(() => {
    const titles = document.head.querySelectorAll('title');
    if (titles.length > 1) {
      // Keep only the last title (the one react-helmet just added)
      for (let i = 0; i < titles.length - 1; i++) titles[i].remove();
    }
    const descs = document.head.querySelectorAll('meta[name="description"]');
    if (descs.length > 1) {
      for (let i = 0; i < descs.length - 1; i++) descs[i].remove();
    }
    const kws = document.head.querySelectorAll('meta[name="keywords"]');
    if (kws.length > 1) {
      for (let i = 0; i < kws.length - 1; i++) kws[i].remove();
    }
    ['og:title', 'og:description', 'og:type'].forEach(prop => {
      const tags = document.head.querySelectorAll(`meta[property="${prop}"]`);
      if (tags.length > 1) {
        for (let i = 0; i < tags.length - 1; i++) tags[i].remove();
      }
    });
    const canonicals = document.head.querySelectorAll('link[rel="canonical"]');
    if (canonicals.length > 1) {
      for (let i = 0; i < canonicals.length - 1; i++) canonicals[i].remove();
    }
  });
  observer.observe(document.head, { childList: true, subtree: true });
  // Stop observing after 5 seconds (hydration is long done by then)
  setTimeout(() => observer.disconnect(), 5000);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}
